import FleetWebApi from "../Api/FleetWebApi";
import { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { TableHead, Box } from "@mui/material";
import Moment from "react-moment";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Collapse from "@mui/material/Collapse";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const excludeFields = [
  "x-forwarded-for",
  "x-forwarded-proto",
  "x-forwarded-port",
  "x-amzn-trace-id",
  "via",
  "x-amz-cf-id"
];



function DeviceEvents(props) {
  const [take] = useState(24);
  const [baseSkip, setBaseSkip] = useState(0);
  const [skip, setSkip] = useState(baseSkip + 0);
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = useState(props.open);

  const nextPage = () => {
    setSkip(skip + take);
  };

  const previousPage = () => {
    setSkip(skip - take);
  };

  const forceRefresh = () => {
    setRefresh(!refresh);
  };
  const handleChange = (event) => {
    if (event) {
      setBaseSkip(parseInt(event.target.value));
    }
  };
  useEffect(() => {
    let isMounted = true;
    setEvents([]);
    setIsLoading(true);
    FleetWebApi.getEventData(
      props.coreId,
      props.eventType,
      props.deviceType,
      baseSkip + skip,
      take
    )
      .then((response) => {
        if (isMounted) {
          setEvents(response);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        if (isMounted) {
          console.log(error);
          setError(error.message);
          setIsLoading(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [skip, take, props.coreId, props.eventType, refresh]);

  return (
    <Paper classes={{ root: "papertable" }}>
      {error && <p>Error Loading Data: {error}</p>}
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Table classes={{ root: "reactivetable fixedTable" }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: "15%" }}>
                Timestamp
              </TableCell>
              <TableCell align="center" style={{ width: "15%" }}>
                Arrival Timestamp
              </TableCell>
              <TableCell align="center" style={{ width: "13%" }}>
                Type
              </TableCell>
              <TableCell align="center" style={{ width: "50%" }}>
                Details
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((row, key) => (
              <TableRow key={key}>
                <TableCell align="center" data-th="Timestamp">
                  {row.timestamp ? (
                    <Moment format="YYYY-MM-DD HH:mm:ss.SSS Z">
                      {row.timestamp}
                    </Moment>
                  ) : (
                    <div>-</div>
                  )}
                </TableCell>
                <TableCell align="center" data-th="Arrival Timestamp">
                  {row.arrival_date ? (
                    <Moment format="YYYY-MM-DD HH:mm:ss.SSS Z">
                      {row.arrival_date}
                    </Moment>
                  ) : (
                    <div>-</div>
                  )}
                </TableCell>
                <TableCell align="center" data-th="Type">
                  {row.type}
                </TableCell>
                <TableCell>
                  <Box classes={{ root: "scrollable" }} style={{
                    display: "grid",
                    justifyContent: "center",
                    fontFamily: "monospace"
                  }}>
                    {typeof row.payload === "object" && row.payload !== null ? (
                      Object.entries(row.payload)
                        .filter(([key]) => !excludeFields.includes(key))
                        .map(([key, value]) => (
                          <div key={key}>
                            {key}:
                            {["date", "timestamp"].includes(key) ? (
                              <>
                                {String(value)}
                                <Tooltip
                                  title={
                                    <span>
                                      <Moment unix format="YYYY-MM-DD HH:mm:ss.SSS Z">{value}</Moment>
                                      <br />
                                      {key === "date"
                                        ? "Time at which the packet arrived at the hub queue"
                                        : "Timeseries block anchor"}
                                    </span>
                                  }
                                >
                                  <IconButton size="small">
                                    <AccessTimeIcon color="secondary" />
                                  </IconButton>
                                </Tooltip>
                              </>
                            ) : (
                              <> {String(value)} </>
                            )}
                          </div>
                        ))
                    ) : (
                      <div data-th="payload">
                        {String(row.payload)}
                      </div>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Collapse>
      {isLoading && <CircularProgress color="secondary" />}
      {skip !== 0 && open && (
        <IconButton onClick={previousPage}>
          <ArrowBackIcon />
        </IconButton>
      )}
      {events.length !== 0 && take === events.length && open && (
        <IconButton onClick={nextPage}>
          <ArrowForwardIcon />
        </IconButton>
      )}
      <IconButton onClick={forceRefresh}>
        <RefreshIcon />
      </IconButton>
      {open ? (
        <TextField
          placeholder="Skip"
          defaultValue={0}
          size="small"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          helperText="Documents to skip (click refresh after)"
          onChange={handleChange}
        />
      ) : null}
      {events.length !== 0 ? (
        <IconButton
          aria-label="expand row"
          size="small"
          onClick={() => setOpen(!open)}
          style={{ marginLeft: 1024 }}
        >
          {open ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
        </IconButton>
      ) : null}
    </Paper>
  );
}

export default DeviceEvents;
